export default "__VITE_ASSET__sze$yI7$__"